import GenericTable from '../../../../cars/components/V3/_shared/GenericTable/GenericTable'
import fleetReportDetailsTableData from './fleetReportDetailsTableData'
import type { Row } from '@tanstack/react-table'
import { formatNumber } from '../../utils/formatNumber'
import TableMobileCardContent from '../../../../cars/components/V3/_shared/GenericTable/TableMobileCardContent'
import type { FleetReportDetails } from '../../../../../types'

type FleetReportDetailsTableProps = {
  data: FleetReportDetails[]
  isLoading?: boolean
}

function FleetReportDetailsTable({ data, isLoading }: FleetReportDetailsTableProps) {
  const columns = fleetReportDetailsTableData()

  return (
    <GenericTable
      className="max-h-[50vh]"
      isLoading={isLoading}
      data={data}
      columns={columns}
      mobileCardContent={(row) => {
        return <MobileCardContent row={row as Row<any>} />
      }}
    />
  )
}

export default FleetReportDetailsTable

function MobileCardContent({ row }: { row: Row<FleetReportDetails> }) {
  const settings = { digits: { min: 0, max: 0 }, prefix: 'kr ' }
  const { description, fixedCostsTerm, nonFixedCostsTerm, totalTerm, totalYear, totalContract } = row.original

  const data = [
    {
      label: 'Kostnadstype',
      value: description || '',
    },
    {
      label: 'Faste kostnader',
      value: formatNumber(fixedCostsTerm, settings),
    },
    {
      label: 'Variable kostnader',
      value: formatNumber(nonFixedCostsTerm, settings),
    },
    {
      label: 'Sum',
      value: formatNumber(totalTerm, settings),
    },
    {
      label: 'Hittil i år',
      value: formatNumber(totalYear, settings),
    },
    {
      label: 'Hittil i kontrakt',
      value: formatNumber(totalContract, settings),
    },
  ]
  const header = `Fleet - ${description}`
  return <TableMobileCardContent header={header} data={data} />
}
